// extracted by mini-css-extract-plugin
module.exports = {"offices":"offices-module--offices--1O71T"};